import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const LEEG = {
  naam: '', bedrijf_naam: '', contactpersoon: '', telefoon: '', email: '',
  adres: '', postcode: '', plaats: '',
  factuur_email: '', factuuradres: '', betaaltermijn: 30, btw_percentage: 21,
  btw_nummer: '', kvk_nummer: '',
  partner_naam: '', partner_email: '', partner_telefoon: '',
  melding_kanaal: 'servicedesk', servicecontract: false, categorie: '', notities: '',
  pdf_secties: { uren: true, lmra: true, checklist: true, opmerkingen: true, logboek: true, fotos: true }
};

const sectie = { margin: '18px 0 8px', color: '#2d3748', fontSize: 14, borderBottom: '1px solid #edf2f7', paddingBottom: 4 };
const inp = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid #cbd5e0', fontSize: 14, boxSizing: 'border-box' };
const rij = { display: 'flex', gap: 12 };

const Veld = ({ label, children }) => (
  <div className="form-group" style={{ flex: 1, marginBottom: 10 }}>
    <label style={{ display: 'block', fontSize: 13, color: '#4a5568', marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

const Opdrachtgevers = () => {
  const { hasPermission } = useAuth();
  const [lijst, setLijst] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoek, setZoek] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(LEEG);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [fout, setFout] = useState('');
  const [portalInv, setPortalInv] = useState(null);
  const [portalBezig, setPortalBezig] = useState(false);
  const [portalMsg, setPortalMsg] = useState(null);

  const magAanmaken = hasPermission('opdrachtgevers:aanmaken');
  const navigate = useNavigate();
  const magBewerken = hasPermission('opdrachtgevers:bewerken');
  const magVerwijderen = hasPermission('opdrachtgevers:verwijderen');
  const magPortalBeheer = hasPermission('portal:beheer');
  const uitnodigenPortal = (o) => { setPortalMsg(null); setPortalInv({ klant: o, naam: '', email: '' }); };
  const verstuurPortalInv = async () => {
    if (!portalInv) return;
    const naam = (portalInv.naam || '').trim();
    const email = (portalInv.email || '').trim();
    if (!naam || !email) { setPortalMsg({ type: 'err', tekst: 'Vul naam en e-mailadres in.' }); return; }
    setPortalBezig(true); setPortalMsg(null);
    try {
      const r = await api.post('/portal-beheer/uitnodigen', { klant_id: portalInv.klant.id, naam, email });
      setPortalMsg({ type: 'ok', tekst: (r.data && r.data.message) || 'Uitnodiging verstuurd.' });
      setPortalInv((p) => p ? { ...p, naam: '', email: '' } : p);
    } catch (e) {
      setPortalMsg({ type: 'err', tekst: (e.response && e.response.data && e.response.data.message) || 'Uitnodigen mislukt.' });
    }
    setPortalBezig(false);
  };

  const laden = async () => {
    setLoading(true);
    try {
      const r = await api.get('/opdrachtgevers');
      setLijst(r.data?.opdrachtgevers || []);
    } catch (e) {
      setFout('Kon opdrachtgevers niet laden');
    } finally { setLoading(false); }
  };
  useEffect(() => { laden(); }, []);

  const openNieuw = () => { setForm(LEEG); setEditId(null); setFout(''); setShowModal(true); };
  const openBewerk = (o) => {
    const gevuld = { ...LEEG };
    Object.keys(LEEG).forEach(k => { if (o[k] != null) gevuld[k] = o[k]; });
    setForm(gevuld); setEditId(o.id); setFout(''); setShowModal(true);
  };

  const veld = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const opslaan = async () => {
    if (!String(form.naam).trim()) { setFout('Naam is verplicht'); return; }
    setSaving(true); setFout('');
    try {
      if (editId) await api.put(`/opdrachtgevers/${editId}`, form);
      else await api.post('/opdrachtgevers', form);
      setShowModal(false);
      await laden();
    } catch (e) {
      setFout(e.response?.data?.message || 'Opslaan mislukt');
    } finally { setSaving(false); }
  };

  const verwijderen = async (o) => {
    if (!window.confirm(`Opdrachtgever "${o.naam}" verwijderen?`)) return;
    try {
      await api.delete(`/opdrachtgevers/${o.id}`);
      await laden();
    } catch (e) {
      alert(e.response?.data?.message || 'Verwijderen mislukt');
    }
  };

  const gefilterd = lijst.filter(o => {
    const q = zoek.toLowerCase();
    return !q || [o.naam, o.bedrijf_naam, o.plaats, o.contactpersoon, o.email].some(x => (x || '').toLowerCase().includes(q));
  });

  if (loading) return <div className="loading-screen">Laden...</div>;

  return (
    <div className="klantenboek">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div>
            <h1 style={{ margin: 0 }}>Opdrachtgevers</h1>
            <p style={{ color: '#718096', margin: '4px 0 0' }}>Beheer je opdrachtgevers en facturatiegegevens</p>
          </div>
          {magAanmaken && <button onClick={openNieuw} className="btn-primary">+ Nieuwe opdrachtgever</button>}
        </div>

        <div style={{ marginBottom: 20 }}>
          <input
            type="text" placeholder="Zoek op naam, bedrijf, plaats…"
            value={zoek} onChange={(e) => setZoek(e.target.value)}
            style={{ width: '100%', maxWidth: 400, padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e0', fontSize: 15, boxSizing: 'border-box' }}
          />
        </div>

        {gefilterd.length === 0 ? (
          <div className="no-werkorders">
            <p>Geen opdrachtgevers gevonden.</p>
            {magAanmaken && <button onClick={openNieuw} className="btn-primary">Voeg je eerste opdrachtgever toe</button>}
          </div>
        ) : (
          <div className="werkorders-list">
            {gefilterd.map(o => (
              <div key={o.id} className="werkorder-card">
                <div className="werkorder-header">
                  <div className="werkorder-title-row">
                    <strong style={{ fontSize: 17 }}>{o.naam}</strong>
                    {o.servicecontract && <span style={{ marginLeft: 8, fontSize: 12, background: '#00D4AA', color: '#fff', padding: '2px 8px', borderRadius: 12 }}>Servicecontract</span>}
                  </div>
                </div>
                {o.bedrijf_naam && <p className="werkorder-meta">🏢 {o.bedrijf_naam}</p>}
                {o.contactpersoon && <p className="werkorder-meta">👤 {o.contactpersoon}</p>}
                {(o.plaats || o.adres) && <p className="werkorder-meta">📍 {[o.adres, o.postcode, o.plaats].filter(Boolean).join(', ')}</p>}
                {o.email && <p className="werkorder-meta">✉️ {o.email}</p>}
                {o.telefoon && <p className="werkorder-meta">📞 {o.telefoon}</p>}
                <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                  <button onClick={() => navigate('/klanten?opdrachtgever_id=' + o.id)} style={{ padding: '6px 14px', background: '#e6fffa', border: '1px solid #00D4AA', color: '#0a7d66', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>📋 Objecten bekijken</button>
                  {magPortalBeheer && <button onClick={() => uitnodigenPortal(o)} style={{ padding: '6px 14px', background: '#eef2ff', border: '1px solid #6366f1', color: '#4338ca', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>📧 Klantportaal uitnodigen</button>}
                </div>
                {(magBewerken || magVerwijderen) && (
                  <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                    {magBewerken && <button onClick={() => openBewerk(o)} style={{ padding: '6px 14px', background: '#edf2f7', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>Bewerken</button>}
                    {magVerwijderen && <button onClick={() => verwijderen(o)} style={{ padding: '6px 14px', background: '#fff', border: '1px solid #e53e3e', color: '#e53e3e', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>Verwijderen</button>}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div onClick={() => setShowModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
          <div className="modal-content klant-modal" style={{ maxWidth: 640, width: '92%', background: '#fff', borderRadius: 12, padding: 24 }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <h2 style={{ margin: 0, fontSize: 20 }}>{editId ? 'Opdrachtgever bewerken' : 'Nieuwe opdrachtgever'}</h2>
              <button onClick={() => setShowModal(false)} className="btn-close" style={{ background: 'none', border: 'none', fontSize: 26, cursor: 'pointer', color: '#718096' }}>×</button>
            </div>
            <div style={{ maxHeight: '68vh', overflowY: 'auto', paddingRight: 4 }}>
              {fout && <div style={{ background: '#fed7d7', color: '#c53030', padding: 10, borderRadius: 6, marginBottom: 12 }}>{fout}</div>}

              <h4 style={sectie}>Algemeen</h4>
              <Veld label="Naam *"><input style={inp} value={form.naam} onChange={e => veld('naam', e.target.value)} /></Veld>
              <Veld label="Bedrijfsnaam"><input style={inp} value={form.bedrijf_naam} onChange={e => veld('bedrijf_naam', e.target.value)} /></Veld>
              <Veld label="Contactpersoon"><input style={inp} value={form.contactpersoon} onChange={e => veld('contactpersoon', e.target.value)} /></Veld>
              <div style={rij}>
                <Veld label="Telefoon"><input style={inp} value={form.telefoon} onChange={e => veld('telefoon', e.target.value)} /></Veld>
                <Veld label="E-mail"><input style={inp} value={form.email} onChange={e => veld('email', e.target.value)} /></Veld>
              </div>

              <h4 style={sectie}>Adres</h4>
              <Veld label="Adres"><input style={inp} value={form.adres} onChange={e => veld('adres', e.target.value)} /></Veld>
              <div style={rij}>
                <Veld label="Postcode"><input style={inp} value={form.postcode} onChange={e => veld('postcode', e.target.value)} /></Veld>
                <Veld label="Plaats"><input style={inp} value={form.plaats} onChange={e => veld('plaats', e.target.value)} /></Veld>
              </div>

              <h4 style={sectie}>Facturatie</h4>
              <Veld label="Factuur-e-mail"><input style={inp} value={form.factuur_email} onChange={e => veld('factuur_email', e.target.value)} /></Veld>
              <Veld label="Factuuradres"><input style={inp} value={form.factuuradres} onChange={e => veld('factuuradres', e.target.value)} /></Veld>
              <div style={rij}>
                <Veld label="Betaaltermijn (dagen)"><input type="number" style={inp} value={form.betaaltermijn} onChange={e => veld('betaaltermijn', e.target.value)} /></Veld>
                <Veld label="BTW %"><input type="number" style={inp} value={form.btw_percentage} onChange={e => veld('btw_percentage', e.target.value)} /></Veld>
              </div>
              <div style={rij}>
                <Veld label="BTW-nummer"><input style={inp} value={form.btw_nummer} onChange={e => veld('btw_nummer', e.target.value)} /></Veld>
                <Veld label="KvK-nummer"><input style={inp} value={form.kvk_nummer} onChange={e => veld('kvk_nummer', e.target.value)} /></Veld>
              </div>

              <h4 style={sectie}>Partner / extra contact</h4>
              <Veld label="Partner naam"><input style={inp} value={form.partner_naam} onChange={e => veld('partner_naam', e.target.value)} /></Veld>
              <div style={rij}>
                <Veld label="Partner e-mail"><input style={inp} value={form.partner_email} onChange={e => veld('partner_email', e.target.value)} /></Veld>
                <Veld label="Partner telefoon"><input style={inp} value={form.partner_telefoon} onChange={e => veld('partner_telefoon', e.target.value)} /></Veld>
              </div>

              <h4 style={sectie}>Overig</h4>
              <Veld label="Meldingskanaal">
                <select style={inp} value={form.melding_kanaal} onChange={e => veld('melding_kanaal', e.target.value)}>
                  <option value="servicedesk">Servicedesk</option>
                  <option value="email">E-mail</option>
                  <option value="portaal">Portaal</option>
                </select>
              
              </Veld>
              <Veld label="Categorie"><input style={inp} value={form.categorie} onChange={e => veld('categorie', e.target.value)} /></Veld>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '10px 0', fontSize: 14, color: '#4a5568' }}>
                <input type="checkbox" checked={!!form.servicecontract} onChange={e => veld('servicecontract', e.target.checked)} />
                Servicecontract actief
              </label>
              <Veld label="Notities"><textarea style={{ ...inp, minHeight: 70 }} value={form.notities} onChange={e => veld('notities', e.target.value)} /></Veld>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '10px 18px', background: '#edf2f7', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Annuleren</button>
              <button onClick={opslaan} disabled={saving} className="btn-primary">{saving ? 'Opslaan…' : 'Opslaan'}</button>
            </div>
          </div>
        </div>
      )}
      {portalInv && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => { setPortalInv(null); setPortalMsg(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 420, maxWidth: '90%' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 4px', color: '#1a202c' }}>Klantportaal uitnodigen</h3>
            <p style={{ margin: '0 0 16px', color: '#718096', fontSize: 13 }}>Eerste Beheerder voor {portalInv.klant.naam}</p>
            <input style={inp} placeholder="Naam contactpersoon" value={portalInv.naam} onChange={(e) => setPortalInv({ ...portalInv, naam: e.target.value })} />
            <div style={{ height: 10 }} />
            <input style={inp} type="email" placeholder="E-mailadres" value={portalInv.email} onChange={(e) => setPortalInv({ ...portalInv, email: e.target.value })} />
            {portalMsg && <div style={{ marginTop: 12, fontSize: 13, color: portalMsg.type === 'ok' ? '#2f855a' : '#c53030' }}>{portalMsg.tekst}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 }}>
              <button onClick={() => { setPortalInv(null); setPortalMsg(null); }} style={{ padding: '10px 18px', background: '#edf2f7', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Sluiten</button>
              <button onClick={verstuurPortalInv} disabled={portalBezig} style={{ padding: '10px 18px', background: '#00D4AA', color: '#06281f', border: 'none', borderRadius: 8, cursor: portalBezig ? 'not-allowed' : 'pointer', fontWeight: 700, opacity: portalBezig ? 0.6 : 1 }}>{portalBezig ? 'Bezig...' : 'Versturen'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Opdrachtgevers;
